/**
 *
 * 用户信息状态管理
 *
 * */
const state = {
  userImg: '' // 用户头像
}

// getters
const getters = {}

// 处理方法
const actions = {
  getItemUser ({ commit }, obj) {
    commit('setItemUser', obj)
  }
}

// mutations
const mutations = {
  setItemUser (state, obj) {
    if (obj.userImg) {
      state.userImg = obj.userImg
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js